/*
 * Copyright 2026 North Carolina State University
 */

import React, { useState } from 'react';
import '../../styles/ManageProgramData.css';  // We can reuse the same CSS
import ChambersReport from './ChambersReport';
import ChamberInventoryReport from './ChamberInventoryReport';
import ProjectsReport from '../shared/ProjectsReport';
import UserAccountsReport from './UserAccountsReport';
import SpaceUseReport from './SpaceUseReport';

const Reporting = () => {
  const [activeSection, setActiveSection] = useState('chambers');

  const renderSection = () => {
    switch (activeSection) {
      case 'chambers': return <ChambersReport />;
      case 'inventory': return <ChamberInventoryReport />;
      case 'projects': return <ProjectsReport />;
      case 'user-accounts': return <UserAccountsReport />;
      case 'space-use': return <SpaceUseReport />;
      default: return <ChambersReport />;
    }
  };

  return (
    <div className="manage-program-container">
      <div className="sidebar">
        <h2>Reports</h2>
        <ul>
          <li>
            <button
              type="button"
              className={activeSection === 'chambers' ? 'active' : ''}
              aria-current={activeSection === 'chambers' ? 'page' : undefined}
              onClick={() => setActiveSection('chambers')}
            >Compartment Project Report</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'inventory' ? 'active' : ''}
              aria-current={activeSection === 'inventory' ? 'page' : undefined}
              onClick={() => setActiveSection('inventory')}
            >Compartment Inventory Report</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'projects' ? 'active' : ''}
              aria-current={activeSection === 'projects' ? 'page' : undefined}
              onClick={() => setActiveSection('projects')}
            >Projects Report</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'user-accounts' ? 'active' : ''}
              aria-current={activeSection === 'user-accounts' ? 'page' : undefined}
              onClick={() => setActiveSection('user-accounts')}
            >User Accounts Report</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'space-use' ? 'active' : ''}
              aria-current={activeSection === 'space-use' ? 'page' : undefined}
              onClick={() => setActiveSection('space-use')}
            >Facility Space Use Report</button>
          </li>
        </ul>
      </div>
      <div className="content-area">
        {renderSection()}
      </div>
    </div>
  );
};

export default Reporting;
